import React from 'react';
import I18n from 'i18n-js';
import qs from 'qs';

import CsrfForm from '../csrf_form';

import { FACEBOOK_AUTH_PATH } from '../url_helpers';

interface Props {
  redirectTo?: string;
  signup?: boolean;
}

export default function FacebookSignin(props: Props) {
  const query = qs.stringify({ redirect_to: props.redirectTo });
  const id = 'facebook-signup-signin';

  const title = props.signup
    ? I18n.t('commons.signupForm.facebookSignup')
    : I18n.t('commons.signupForm.facebookSignin');

  return (
    <CsrfForm
      id={id}
      method="post"
      action={`${FACEBOOK_AUTH_PATH}?${query}`}
    >
      <input type="hidden" name="name" value="value" />
      <button
        type="submit"
        form={id}
        className="signup-signin__form__facebook__link"
      >
        {title}
      </button>
    </CsrfForm>
  );
}
